// JsFromRoutes CacheKey eff74a183e21a5cf058e28b088b71b50
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/password_strength_checks'),
}
